import Vue from 'vue'
import Router from 'vue-router'
import * as firebase from 'firebase'
import { firebaseConfig } from '@/configs'
import Accueil from '@/components/Accueil'
import Compte from '@/components/Compte'
import ChangePassword from '@/components/ChangePassword'
import Login from '@/components/Authentification/Login'
import Landing from '@/components/Landing'
import ResetPassword from '@/components/Authentification/ResetPassword'
import MainLayout from '@/components/Layouts/MainLayout'
import AdminHome from '@/components/Administration/Home'
import Notifications from '@/components/Notification/Notifications'
import Reports from '@/components/Report/Reports'
import EditReport from '@/components/Report/EditReport'

Vue.use(Router)
firebase.initializeApp(firebaseConfig)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/landing'
    },
    {
      path: '/',
      redirect: '/landing'
    },
    {
      path: '/accueil',
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', props: true, component: Accueil }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {requiresNoAuth: true}
    },
    {
      path: '/landing',
      name: 'Landing',
      component: Landing,
      meta: {requiresNoAuth: true}
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true,
      meta: {requiresNoAuth: true}
    },
    {
      path: '/administration',
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', name: 'admin_home', component: AdminHome }
      ]
    },
    {
      path: '/compte',
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', name: 'compte', component: Compte }
      ]
    },
    {
      path: '/changepassword',
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', name: 'changepassword', component: ChangePassword }
      ]
    },
    {
      path: '/notifications',
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', name: 'notifications', component: Notifications }
      ]
    },
    {
      path: '/reports',
      props: true,
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', props: true, name: 'reports', component: Reports }
      ]
    },
    {
      path: '/report/:id',
      props: true,
      component: MainLayout,
      meta: {requiresAuth: true},
      children: [
        { path: '', props: true, name: 'edit_report', component: EditReport }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      console.log('User' + JSON.stringify(user))
      if (!user) {
        next({
          path: '/login'
        })
      } else {
        next()
      }
    })
  } else {
    next()
  }
  if (to.matched.some(record => record.meta.requiresNoAuth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next({
          path: '/accueil'
        })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js